export default "__VITE_PUBLIC_ASSET__a264a9a5__"